// @ai-generated 2026-08-28T00:00:00+00:00 by matthias.gessinger@synqony.com using Claude Opus 5 (1M context)
import { type ApiOrderSnapshot } from '@Model';
import { isLinked } from '@synqo/frontend-component-library';

/** One invoice a requisition was billed into, as the portal can reach it. */
export interface PortalRequisitionInvoice {
    /** Id of the invoice snapshot — the portal's `/:subpath/invoices/:id` route parameter. */
    id: string;

    /** Invoice number, which is what the customer recognises. Empty when the snapshot carries none. */
    number: string;
}

/**
 * The invoices a requisition's orders were billed into, in the order they first appear.
 *
 * Billing links every order position to the invoice that billed it, so one requisition can end up
 * with several invoices — split across its orders, or across a partially billed one. The distinct set
 * is what the customer cares about, because the usual case is a single invoice for everything.
 */
export function collectPortalRequisitionInvoices(
    snapshots: readonly ApiOrderSnapshot[] | undefined,
): PortalRequisitionInvoice[] {
    const byId = new Map<string, PortalRequisitionInvoice>();

    for (const snapshot of snapshots ?? []) {
        for (const position of snapshot.positions) {
            if (!isLinked(position.invoice)) {
                continue;
            }

            const id = position.invoice.foreign_key;
            if (id !== undefined && !byId.has(id)) {
                byId.set(id, { id, number: position.invoice.display_string });
            }
        }
    }

    return [...byId.values()];
}
